<template>
  <div class="container my-4">
    <!-- Heading -->
    <div class="heading" role="alert">
      <h4>📊 Attendance Summary</h4>
    </div>

    <!-- Filters -->
    <div class="mb-4 d-flex flex-column flex-sm-row align-items-start gap-2">
      <select v-model="selectedInstitute" class="form-select">
        <option value="">All Institutes</option>
        <option v-for="institute in institutes" :key="institute.id" :value="institute.id">
          {{ institute.institute_name }}
        </option>
      </select>

      <select v-model="selectedSubject" class="form-select">
        <option value="">All Subjects</option>
        <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
          {{ subject.name }}
        </option>
      </select>

      <select v-model="selectedGrade" class="form-select">
        <option value="">All Grades</option>
        <option v-for="grade in grades" :key="grade.id" :value="grade.id">
          Grade {{ grade.grade_level }}
        </option>
      </select>

      <input type="date" v-model="selectedDate" class="form-control" />
    </div>

    <!-- Loading Spinner -->
    <div v-if="loading" class="text-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Message Label -->
    <div v-else-if="message" class="alert alert-warning">
      {{ message }}
    </div>

    <div v-if="counts" class="mb-3">
  <span class="badge bg-primary me-2">
    Total Students: {{ counts.total_students }}
  </span>
  <span class="badge bg-success me-2">
    Present: {{ counts.present }}
  </span>
  <span class="badge bg-danger">
    Absent: {{ counts.absent }}
  </span>
</div>

    <!-- Attendance Table -->
    <!-- <table v-else class="table table-bordered table-striped"> -->
      <table v-if="studentsAttendance.length" class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>Student</th>
          <th>Grade</th>
          <th>Institute</th>
          <th>Status</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="student in studentsAttendance" :key="student.id">
          <td>{{ student.name }}</td>
          <td>{{ student.grade_level || '-' }}</td>
          <td>{{ student.institute_name || '-' }}</td>
          <td>
            <span v-if="student.attendance_status === 'present'" class="text-success fw-bold">
              ✅ Present
            </span>
            <span v-else class="text-danger fw-bold">❌ Absent</span>
          </td>
          <!-- <td>
            <span v-if="student.attendance_status === 'present'" class="text-success fw-bold">
              ✅ Present
            </span>
            <span v-else-if="student.attendance_status === 'absent'" class="text-danger fw-bold">
              ❌ Absent
            </span>
            <span v-else class="text-secondary fw-bold">
              ⏳ Not Marked
            </span>
          </td> -->
          <td>
            <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#remarkModal" @click="selectedRemark = student.remarks || 'No remark'">
              View
            </button>
          </td>
          <!-- <td>{{ student.remarks || '-' }}</td> -->
        </tr>
      </tbody>
    </table>


    <!-- Modal -->
<div class="modal fade" id="remarkModal" tabindex="-1" aria-labelledby="remarkModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="remarkModalLabel">Student Remark</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        {{ selectedRemark }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      selectedSubject: "",
      selectedGrade: "",
      selectedInstitute: "",
      selectedDate: new Date().toISOString().slice(0, 10),

      subjects: [],
      grades: [],
      institutes: [],
      studentsAttendance: [],
      message: "", // message for no data or error
      loading: false, // loading spinner
      counts: null,
      selectedRemark: '',
    };
  },

  methods: {
    async fetchGrades() {
      const teacherId = localStorage.getItem("teacher_id");
      const { data } = await axios.post("/get-teacher-teach-grade", { teacher_id: teacherId });
      this.grades = data;
    },

    async fetchSubjects() {
      const teacherId = localStorage.getItem("teacher_id");
      const { data } = await axios.post("/get-teacher-teach-subjects", { teacher_id: teacherId });
      this.subjects = data;
    },

    async fetchInstitutes() {
      const teacherId = localStorage.getItem("teacher_id");
      const { data } = await axios.post("/get-teacher-teach-institutes", { teacher_id: teacherId });
      this.institutes = data;
    },

    async loadAttendance() {
      const teacherId = localStorage.getItem("teacher_id");
      this.loading = true;
      this.message = "";
      this.studentsAttendance = [];
      this.counts = null;

      try {
        const { data } = await axios.post("/get-attendance-with-students", {
          teacher_id: teacherId,
          subject_id: this.selectedSubject,
          grade_id: this.selectedGrade,
          institute_id: this.selectedInstitute,
          attendance_date: this.selectedDate,
        });

        if (!data.success || data.data.length === 0) {
          this.message = data.message || "Attendance not available.";
        } else {
          this.studentsAttendance = data.data;
          this.counts = data.counts;
        }
      } catch (error) {
        console.error("Error loading attendance:", error);
        this.message = "Error loading attendance. Please try again.";
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    selectedSubject: "loadAttendance",
    selectedGrade: "loadAttendance",
    selectedInstitute: "loadAttendance",
    selectedDate: "loadAttendance",
  },

  mounted() {
    this.fetchInstitutes();
    this.fetchGrades();
    this.fetchSubjects();
    this.loadAttendance();
  },
};
</script>

<style lang="scss" scoped>
.heading{
    background-color: #696969;
    border: 2px solid #b8b8b8;
    border-radius: 5px;
    padding: 10px;
    color: white;
    margin-bottom: 5dvh;
  }
</style>